import { render, staticRenderFns } from "./whos-viewing-indicator.vue?vue&type=template&id=daf4e51a&"
import script from "./whos-viewing-indicator.vue?vue&type=script&lang=ts&"
export * from "./whos-viewing-indicator.vue?vue&type=script&lang=ts&"
import style0 from "./whos-viewing-indicator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports